import { render, staticRenderFns } from "./MatchMakingSettings.vue?vue&type=template&id=6e17e2dc&scoped=true"
import script from "./MatchMakingSettings.vue?vue&type=script&lang=js"
export * from "./MatchMakingSettings.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingSettings.vue?vue&type=style&index=0&id=6e17e2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17e2dc",
  null
  
)

export default component.exports